export const ACTION_STATUS = {
  IN_PROGRESS: 'API_IN_PROGRESS',
  SUCCESS: 'API_SUCCESS',
  FAILURE: 'API_FAILURE',
};
